import MaterialTable from '@material-table/core';
import React from 'react';
import moment from 'moment';
import {
  modifyDefaultLocalization,
  modifyDefaultOptions,
} from '../../helpers/table';
import { Delete } from '@material-ui/icons';
import copyLinkIcon from '../../../img/icons/documents-components/share.svg'
import Tooltip from "@mui/material/Tooltip";
import {IconButton} from "@material-ui/core";
import FileIcon from '../UI/icons/FileIcon';
import './FolderViewTable.less';
import DocumentTableActions from "../common/Actions/DocumentTableActions";

function NameCell({ type, name, contentType }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        fontWeight: type === 'folder' ? 'bold' : undefined,
      }}
    >
      <FileIcon
        iconCode={type === 'folder' ? 'folder' : null}
        mimetype={contentType}
        style={{ marginRight: '12px' }}
      />
      {name}
    </div>
  );
}

const renderDate = (createdOn) =>
  moment.utc(createdOn).format('DD.MM.YYYY HH:mm');

export default function FolderViewTable(props) {
  return (
    <MaterialTable
      title={null}
      onRowClick={(event, item) => {
          props.onRowClick(item)
      }}
      localization={modifyDefaultLocalization({ header: { actions: '' } })}
      options={modifyDefaultOptions({
        search: false,
        filtering: false,
        draggable: false,
        actionsColumnIndex: -1,
        rowStyle: (rowData) => ({
          backgroundColor: '#FFF',
        }),
      })}
      columns={[
        {
          title: 'Название',
          field: 'name',
          render: ({ type, name, contentType }) => (
            <NameCell type={type} name={name} contentType={contentType} />
          ),
        },
        {
          title: 'Дата создания',
          field: 'createdOn',
          render: ({ createdOn }) => renderDate(createdOn),
        },
        { title: 'Автор создания', field: 'creatorName' },
      ]}
      actions={[
        {
          perms: props.permissions.canDelete,
          types: ['folder', 'file'],
          custom: true,
          icon: <Delete style={{ color: '#D62D2B' }} />,
          tooltip: 'Удалить',
          onClick: (event, item) => {
            event.stopPropagation();
            props.onActionDelete(item);
          },
        },
        {
          perms: props.permissions.canCopyLink,
          types: ['file'],
          custom: true,
          icon: <img src={copyLinkIcon}/>,
          tooltip: 'Скопировать ссылку',
          onClick: async (event, item) => {
            event.stopPropagation();
            props.onActionCopyText(item);
          },
        }
      ]}
      components={{
          Toolbar: () => null,
          Actions: actionProps => {
              return (
                  <div style={{display: 'flex'}} 
                    onClick={(event)=>{event.stopPropagation()}}>
                    {
                      <DocumentTableActions
                          props={{
                            data: actionProps.data,
                            permissions: props.permissions,
                          }}
                          actions={{
                            rename: (e) => {
                              props.onActionRename(actionProps.data);
                              e.stopPropagation()
                            },
                            access: (e) => {
                              props.onActionAccess(actionProps.data);
                              e.stopPropagation()
                            },
                          }}
                      />
                        }
                        <div style={{display: 'flex'}}>{actionProps.actions.map((element, i) => {
                          return (
                            element.perms && element.types.includes(actionProps.data.type)
                            ? <Tooltip key={i} title={element.tooltip}>
                              <IconButton aria-label={element.icon}
                                  onClick = {(e) => element.onClick(e, actionProps.data)}
                              >
                                  {element.icon}
                              </IconButton>
                            </Tooltip>
                            : null
                            )
                        })}</div>
                  </div>
              );
          },
      }}
      data={props.content}
    />
  );
}
